<template>
  <div class="custom-view-wrapper">
    <div class="steps__content">
      <div class="step mb-2" v-for="step in steps">
        <span class="step__comment">{{ step.comment }}</span>
        <em class="step__date">{{ formatDate(step.created_at) }}</em>
      </div>
    </div>
    <div class="steps__footer">
      <button class="btn" @click="close">{{ closeText }}</button>
    </div>
  </div>
</template>

<script>
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import i18n from '@/lang';

export default {
  name: "ContractStepsDialog",
  mixins: [DialogMixin],
  computed: {
    steps() {
      return this.options.steps;
    },
    closeText() {
      return i18n.t('ContractStep.steps.close');
    }
  },
  methods: {
    formatDate(date) {
      const dateAsString = moment(date).format(i18n.t('format.date_at_time'));
      return i18n.t('ContractStep.step.date', { date: dateAsString });
    },
    trans(key) {
      return i18n.t(key);
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/pages/_var.scss';

.steps__content {
  border-left: 3px $color-pink solid;
  padding-left: 20px;
}
.steps__footer {
  margin-top: 25px;
  padding-top: 10px;
  border-top: 1px $color-master-light solid;
}
.step__comment, .step__date {
  color: $color-master-darkest;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractStepsDialog.vue